import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PdfInvoice from "./PdfInvoice";
import {
  Download,
  FileText,
  Eye
} from "lucide-react";

export default function InvoicePreview(props) {

  const fileName = `${ props.customer.name || "Invoice"}-${ props.documentType || "Invoice"}.pdf`;

  return (
    <div className="w-full">

      {/* HEADER */}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">

        <div>

          <div className="flex items-center gap-3 mb-1">

            <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center text-white shadow-lg">
              <FileText size={20} />
            </div>

            <div>
              <h2 className="text-2xl font-bold text-slate-800">
                Invoice Preview
              </h2>

              <p className="text-sm text-slate-500">
                Live PDF invoice rendering
              </p>
            </div>

          </div>

        </div>

        {/* TAX BADGE */}

        <div
          className={`px-4 py-2 rounded-2xl text-sm font-semibold w-fit ${
            props.taxMode === "igst"
              ? "bg-blue-100 text-blue-700"
              : "bg-green-100 text-green-700"
          }`}
        >
          {props.taxMode === "igst"
            ? "IGST MODE"
            : "CGST + SGST MODE"}
        </div>

      </div>

      {/* PDF VIEWER */}

      <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-slate-100 shadow-inner">

        {/* TOP BAR */}

        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200 bg-white">

          <div className="flex items-center gap-2">

            <div className="w-3 h-3 rounded-full bg-red-400" />
            <div className="w-3 h-3 rounded-full bg-yellow-400" />
            <div className="w-3 h-3 rounded-full bg-green-400" />

          </div>

          <div className="flex items-center gap-2 text-sm text-slate-500">

            <Eye size={16} />

            <span className="hidden sm:inline">
              PDF Live Preview
            </span>

          </div>

        </div>

        {/* PDF */}

        <div className="h-[500px] sm:h-[650px] bg-white">

          <PDFViewer
            width="100%"
            height="100%"
            showToolbar={true}
          >
            <PdfInvoice {...props} />
          </PDFViewer>

        </div>

      </div>

      {/* ACTIONS */}

      <div className="mt-5 flex flex-col sm:flex-row gap-4">

        <PDFDownloadLink
          key={JSON.stringify({
            customer: props.customer,
            totals: props.totals,
            items: props.items,
            payment: props.payment,
            invoiceNo: props.invoiceNo,
            taxMode: props.taxMode,
            documentType: props.documentType,
          })}
          document={<PdfInvoice {...props} />}
          fileName={fileName}
          className="flex items-center justify-center gap-3 bg-gradient-to-r from-purple-600 to-blue-600 hover:opacity-90 text-white px-6 py-3 rounded-2xl font-semibold shadow-lg transition-all duration-300 hover:scale-[1.02]"
        >

          {({ loading }) => (
            <>
              <Download size={18} />

              {loading
                ? "Preparing PDF..."
                : "Download Invoice PDF"}
            </>
          )}

        </PDFDownloadLink>

        {/* QUICK INFO */}

        <div className="flex-1 bg-slate-50 border border-slate-200 rounded-2xl px-5 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">

          <div>
            <p className="text-xs text-slate-500">
              Invoice Number
            </p>

            <p className="font-semibold text-slate-800">
              {props.invoiceNo || "N/A"}
            </p>
          </div>

          <div>
            <p className="text-xs text-slate-500">
              Customer
            </p>

            <p className="font-semibold text-slate-800">
              {props.customer.name || "Not Added"}
            </p>
          </div>

          <div>
            <p className="text-xs text-slate-500">
              Total Amount
            </p>

            <p className="font-bold text-green-700">
              ₹{" "}
              {props.totals.total?.toLocaleString(
                "en-IN",
                { maximumFractionDigits: 0 }
              ) || "0"}
            </p>
          </div>

        </div>

      </div>

    </div>
  );
}